import { Component, OnInit, Input } from '@angular/core';
import { DnDialogService } from '../dn-dialog.service';
import { NumberFormatStyle } from '../../../../../node_modules/@angular/common';

@Component({
  selector: 'app-dn-dialog-button',
  templateUrl: './dn-dialog-button.component.html',
  styleUrls: ['./dn-dialog-button.component.scss']
})
export class DnDialogButtonComponent implements OnInit {
  @Input()
  dialog: string;
  @Input()
  buttonText = '关闭';
  @Input()
  buttonStyle = {};
  @Input()
  buttonHoverStyle = {};

  hover = false;

  constructor(
    private _dnDialogService: DnDialogService,
  ) { }

  ngOnInit() {
  }

  closeDialog() {
    if (!this.dialog) {
      return;
    }

    this._dnDialogService.close(this.dialog);
  }

  getStyle() {
    if (this.hover) {
      return this.buttonHoverStyle;
    } else {
      return this.buttonStyle;
    }
  }

  onMouseEnter() {
    this.hover = true;
  }

  onMouseLeave() {
    this.hover = false;
  }
}
